import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect, ReactReduxContext } from 'react-redux';

import ResizeOverlay from '@/components/ResizeOverlay/ResizeOverlay.js';

import actions from '@/action/selection.js';

import styles from './Resize.module.css';
//import overlayStyles from '@/components/ResizeOverlay/ResizeOverlay.module.css';

/** 
 * <p></p>
 */

const margin = 20;
const handles = [
    styles.nw, styles.n, styles.ne,
    styles.w, styles.e,
    styles.sw, styles.s, styles.se
]

class Resize extends Component {
    constructor(props) {
        super(props);
        this.margin = props.margin || margin
    }

    /**
     * Ok componentDidMount desc
     */
    // componentDidMount() {

    // }
    // componentWillUnmount() {

    // }

    // handleMouseDown(e) {

    // }
    // handleMouseUp(e) {

    // }


    // handleMouseMove(e) {

    // }

    componentWillUpdate(nextProps) {
        // console.log('inactiveHandle??', nextProps.activeHandle)
        if (nextProps.activeHandle == null 
            && this.props.activeHandle) {
            this.inactiveHandle = this.props.activeHandle;
        } else {
            this.inactiveHandle = null;
        }
    }

    render() {
        const style = this.props.x ? {
            left: this.props.x,
            top: this.props.y,
            width: this.props.width + (this.margin*2),
            height: this.props.height + (this.margin*2),
            margin: -this.margin
        }:{};

        let active = this.props.activeHandle ? styles.active : styles.inactive;

        return <div
            className={`${styles.resizeControl} ${active}`}
            style={style}
        >
            <div className={`${styles.handle} ${styles.nw} ${this.props.activeHandle == styles.nw ? styles.active:(this.inactiveHandle == styles.nw ? styles.inactive : '')}`}><div className={styles.shape}></div></div>
            <div className={`${styles.handle} ${styles.n} ${this.props.activeHandle == styles.n ? styles.active:(this.inactiveHandle == styles.n ? styles.inactive : '')}`}><div className={styles.shapeEdgeH}></div></div>
            <div className={`${styles.handle} ${styles.ne} ${this.props.activeHandle == styles.ne ? styles.active:(this.inactiveHandle == styles.ne ? styles.inactive : '')}`}><div className={styles.shape}></div></div>
            <div className={`${styles.handle} ${styles.w} ${this.props.activeHandle == styles.w ? styles.active:(this.inactiveHandle == styles.w ? styles.inactive : '')}`}><div className={styles.shapeEdgeV}></div></div>
            <div className={`${styles.handle} ${styles.e} ${this.props.activeHandle == styles.e ? styles.active:(this.inactiveHandle == styles.e ? styles.inactive : '')}`}><div className={styles.shapeEdgeV}></div></div>
            <div className={`${styles.handle} ${styles.sw} ${this.props.activeHandle == styles.sw ? styles.active:(this.inactiveHandle == styles.sw ? styles.inactive : '')}`}><div className={styles.shape}></div></div>
            <div className={`${styles.handle} ${styles.s} ${this.props.activeHandle == styles.s ? styles.active:(this.inactiveHandle == styles.s ? styles.inactive : '')}`}><div className={styles.shapeEdgeH}></div></div>
            <div className={`${styles.handle} ${styles.se} ${this.props.activeHandle == styles.se ? styles.active:(this.inactiveHandle == styles.se ? styles.inactive : '')}`}><div className={styles.shape}></div></div>
            {
                (this.props.activeHandle || this.inactiveHandle) ? <ResizeOverlay /> : null
            }
            
        </div>;
    }
}

const mapStateToProps = (state, ownProps) => {
    // console.log(state);

    const activeHandle = state.content.active.length > 0
    && handles.indexOf(state.content.active[state.content.active.length-1]) !== -1
    ? 
    state.content.active[state.content.active.length-1] : null;

    // console.log('activeHandle', activeHandle);

    return Object.assign({
        activeHandle
    }, ownProps);
}


Resize.displayName = "ResizeComponent";

const connectedComponent = connect(
    mapStateToProps,
    {
        ...actions
    }
)(Resize);
connectedComponent.displayName = "Resize";


Resize.propTypes = {
    /**
     * Full Configuration object
     */

};

export default connectedComponent;
export { Resize as ResizeComponent };